module.exports = __webpack_public_path__ + "static/media/img1.16ed6529.gif";